module.exports = __webpack_public_path__ + "static/img/personnote_img_avatar1.7b025ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personnote_img_avatar1.png
// module id = qiMd
// module chunks = 0